import { PageLoading } from 'embroil/components/loading';

<template>
  <PageLoading @message="Loading game details..." @subtitle="Getting game information, reviews, and media" />
</template>
